import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Stack, Tooltip, Typography } from '@mui/material'

import { NETWORK_GROWTH_INFO } from 'components/reports/Metrics/constants/NetworkGrowth'

import { NetworkGrowthCards } from './NetworkGrowthCards'
import { NetworkGrowthFilterCriteria } from './NetworkGrowthFilterCriteria'
import { NetworkGrowthFiltersForm } from './NetworkGrowthFilters'
import { NetworkGrowthFootnote } from './NetworkGrowthFootnote'

export const NetworkGrowth = () => (
  <NetworkGrowthFilterCriteria>
    <Box>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', lg: 'flex-end' }}
        justifyContent='space-between'
        mb={3}>
        <Box>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Typography variant='h5' fontWeight={700} sx={{ color: 'primary.main' }}>
              Network Growth &amp; Engagement
            </Typography>
            <Tooltip
              title={NETWORK_GROWTH_INFO}
              slotProps={{ tooltip: { sx: { whiteSpace: 'pre-line', maxWidth: 420 } } }}>
              <InfoOutlinedIcon fontSize='small' sx={{ color: 'text.disabled' }} />
            </Tooltip>
          </Stack>
          <Typography variant='body2' color='text.secondary'>
            Track supplier growth, engagement and jobs completed across OP and CX.
          </Typography>
        </Box>

        <NetworkGrowthFiltersForm />
      </Stack>

      <NetworkGrowthCards />

      <NetworkGrowthFootnote />
    </Box>
  </NetworkGrowthFilterCriteria>
)
